import { FeatureTooltip } from '@karnov/kui-react'

import { FC } from 'react'

import { Link, useLocation } from 'react-router-dom'

import { useIsPanelOpen } from 'stores/usePanelsStateStore'

import { cn } from 'utils/cn'

type Props = {
  decorator?: React.ReactNode
  icon: React.ReactNode
  onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void
  title: string
  titleShort: string
  tooltipContent: string
  url?: string
  isExternal?: boolean
}

export const ConversationsHistoryLink: FC<Props> = ({
  icon,
  title,
  titleShort,
  url,
  onClick,
  decorator,
  tooltipContent,
  isExternal,
}) => {
  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')

  const location = useLocation()
  const isActivePage = location.pathname === url

  return (
    <FeatureTooltip
      content={tooltipContent}
      disabled={isConversationMenuPanelOpen}
      side="right"
    >
      <Link
        className={cn('kui-btn kui-btn-plain kui-btn-fullwidth p-2 w-full rounded-lg flex justify-items-center !no-underline hover:!bg-subdued !text-default', {
          'flex-row': isConversationMenuPanelOpen,
          'flex-col mb-2': !isConversationMenuPanelOpen,
          'bg-dark': isActivePage,
          'justify-start': isConversationMenuPanelOpen,
        })}
        onClick={onClick}
        to={url || '#'}
        target={isExternal ? '_blank' : '_self'}
      >
        <span className="w-4">
          {icon}
        </span>
        {isConversationMenuPanelOpen
          ? (
              <div className="ml-2 flex-1 overflow-hidden text-ellipsis text-nowrap text-base font-medium">
                {title}
              </div>
            )
          : (
              <div className="mt-1 text-sm">
                {titleShort}
              </div>
            )}
        {isConversationMenuPanelOpen && decorator}
      </Link>
    </FeatureTooltip>
  )
}
